<template>
  <header class="header_area header_type_2 fixed-top">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="header_main_wrap">
            <div class="header_left">
              <button class="hamburger_btn" @click="toggleMobileMenu" aria-label="Toggle menu">
                <span></span>
                <span></span>
                <span></span>
              </button>
              <div class="collapse_arrow">
                <span @click="toggleLeftMenuCollapse"
                  ><i class="lni-text-align-right"></i
                ></span>
              </div>
              <div class="logo">
                <router-link :to="{ name: 'dashboard' }">
                  <!--                  <img src="@/assets/media/images/logo-new.png" class="" alt="" style=" width: 133px;">-->
                </router-link>
              </div>
              <div class="header_search">
                <!--<img src="@/assets/media/images/search.png" alt="">
                <input type="text" >-->
              </div>
            </div>
            <div class="header_right_menu">
              <ul>
                <!-- <li class="below_mobile"><a href="#"><img src="assets/media/images/search.png" alt=""></a></li> -->
                <li class="vendor_logo" @click.prevent="logout">
                  <a href="#">Logout</a>
                </li>
                <li class="logged_in_link" title="Latest Ticket Requests">
                  <div class="dropdown">
                    <button class="btn">
                      <span>{{ supportRequests.length }}</span>
                      <img
                        src="@/assets/media/images/header_icon1.png"
                        alt=""
                      />
                    </button>
                    <div class="dropdown_menu">
                      <h3
                        class="ml_15 pb_15 pt_15"
                        style="
                          border-bottom: 1px solid #ddd;
                          margin-right: 15px;
                        "
                      >
                        Latest ticket requests
                      </h3>
                      <ul>
                        <li
                          class="d-block background"
                          v-for="(supportRequest, index) in supportRequests"
                          :key="'request_' + index"
                        >
                          <router-link
                            :to="`/ticket/${supportRequest.ticket_number}`"
                            >{{ supportRequest.ticket_number }}:
                            {{ supportRequest.subject }}</router-link
                          >
                          <p class="ml_15 mb_0">
                            {{ supportRequest.formatted_created_at }}
                          </p>
                        </li>
                      </ul>
                      <router-link
                        :to="{ name: 'tickets' }"
                        class="btn btn_sm btn_black has_border_radius"
                        >View all</router-link
                      >
                    </div>
                  </div>
                </li>
                <!-- <li class="logged_in_link">
                  <router-link to="/chat"
                    ><img src="@/assets/media/images/header_icon2.png" alt=""
                  /></router-link>
                </li> -->
                <li class="logged_in_link" title="Latest Ticket Replies">
                  <div class="dropdown">
                    <button class="btn">
                      <span>{{ latestReplies?.length }}</span>
                      <img
                        src="@/assets/media/images/header_icon2.png"
                        alt=""
                      />
                    </button>
                    <HeaderNotificationsComponent />
                  </div>
                </li>
                <li class="logged_in_link" title="Mute / Unmute">
                  <div class="dropdown">
                    <button class="btn" @click="toggleNotification">
                      <svg
                        v-if="isMuteNotification === 'true'"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="text_white"
                      >
                        <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        <path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path>
                        <path
                          d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"
                        ></path>
                        <path d="M18 8a6 6 0 0 0-9.33-5"></path>
                        <line x1="1" y1="1" x2="23" y2="23"></line>
                      </svg>
                      <img
                        v-else
                        src="@/assets/media/images/header_icon3.png"
                        alt=""
                      />
                    </button>
                  </div>
                </li>
                <li class="logged_in_link">
                  <router-link to="/profile">
                    <img src="@/assets/media/images/header_icon4.png" alt="" />
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderNotificationsComponent from '@/components/shared/HeaderNotificationsComponent.vue';
import { echo } from '@/services/echo';
import { Howl } from 'howler';
import store from '@/store';

export default {
  components: { HeaderNotificationsComponent },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      socketUrl: process.env.VUE_APP_SOCKET_URL,
      appUrl: process.env.VUE_APP_URL,
      incomingMessageSound: null,
      soundInterval: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
      notifications: 'notification/notificationList',
      supportRequests: 'notification/supportRequests',
      latestReplies: 'notification/latestReplies',
      isMuteNotification: 'settings/isMuteNotification',
      isMobileMenuOpen: 'settings/isMobileMenuOpen',
    }),
  },
  watch: {
    $route() {
      window.$('.dropdown_menu').removeClass('open');
    },
  },
  created() {
    if (this.user) {
      store.dispatch('notification/loadLatestPendingTickets');
      store.dispatch('notification/loadLatestReplies');
    }
    this.incomingMessageSound = new Howl({
      src: [`${this.appUrl}/notify-audio.mp3`],
      volume: 1.0,
      html5: true, // Optional: use HTML5 audio for longer sounds
      preload: true,
    });
  },
  mounted() {
    this.initEchoListeners();
    this.soundInterval = setInterval(() => {
      if (!this.user) return;
      store.dispatch('notification/loadLatestPendingTickets');
      store.dispatch('notification/loadLatestReplies');
      if (this.incomingMessageSound.playing()) {
        this.incomingMessageSound.stop(); // Stop previous sound if still playing
      }
      if (this.supportRequests.length > 0) {
        if (this.isMuteNotification === 'true') return;
        this.incomingMessageSound.play();
      }
    }, 60000);
  },
  beforeUnmount() {
    echo.leaveChannel(`antel_new_ticket`);
    echo.leaveChannel(`antel_new_reply`);
    echo.leaveChannel(`antel_ticket_seen`);
    clearInterval(this.soundInterval);
  },
  methods: {
    initEchoListeners() {
      this.realTimeTicketUpdateInit();
      this.realTimeRepliesInit();
    },
    playIncomingMessageSound() {
      if (this.isMuteNotification === 'true') return;
      this.incomingMessageSound.play();
    },
    realTimeTicketUpdateInit() {
      echo
        .channel(`antel_new_ticket`)
        .listen('.antel_new_ticket.created', (e) => {
          this.playIncomingMessageSound();
        });
    },
    realTimeRepliesInit() {
      echo
        .channel(`antel_new_reply`)
        .listen('.antel_new_reply.created', (e) => {
          store.dispatch('notification/loadLatestReplies');
          this.playIncomingMessageSound();
        });

      // 👇 Add this new listener
      echo
        .channel(`antel_ticket_seen`)
        .listen('.antel_ticket_seen.updated', (e) => {
          store.dispatch('notification/loadLatestReplies');
        });
    },
    toggleNotification() {
      if (this.isMuteNotification === 'true') {
        this.$store.dispatch('settings/getIsMuteNotification', 'false');
      } else {
        this.$store.dispatch('settings/getIsMuteNotification', 'true');
      }
    },
    toggleLeftMenuCollapse() {
      window.$('body').toggleClass('left_menu_collapse');
      if (window.$('body').hasClass('left_menu_collapse')) {
        this.$store.dispatch('settings/getIsMenuCollapse', true);
        this.hideOtherNav('.left_nav_list > li', '.left_f_list');
        this.hideOtherNav('.left_nav_level2', '.left_f_list_level2');
        this.hideOtherNav('.left_nav_level3', '.left_f_list_level3');
      } else {
        this.$store.dispatch('settings/getIsMenuCollapse', false);
      }
    },
    hideOtherNav(
      selector = '.left_nav_list > li',
      finderSelector = '.left_f_list'
    ) {
      var list = window.$(selector);
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        var elementId = window.$(element).find(finderSelector).data('target');
        window.$(window.$(element).find(finderSelector).removeClass('open'));
        window.$(elementId).hide();
      }
    },
    // loadUnreadRequests(){
    //   this.axios.get('unread-requests').then((response) => {
    //     this.supportRequests = response.data.data;
    //   })
    // },
    reload(name) {
      if (this.$route.name === name) {
        this.$store.commit('setReload', true);
      }
    },
    logout() {
      this.axios.post('/logout').finally(() => {
        this.$store.dispatch('auth/logout');
        this.$router.push({ name: 'login' });
      });
    },
    toggleMobileMenu() {
      this.$store.dispatch('settings/toggleMobileMenu');
    },
  },
};
</script>

<style scoped>
.dropdown_menu {
  min-width: 250px;
}
.background {
  background: #f6f6f6;
  margin-bottom: 5px;
  padding: 5px 0;
}
</style>
